(function ($)
{
	window.Symbol = function (sWSODIssue, iMonths)
	{
		this.InputData = {
			WsodIssue: sWSODIssue || "",
			months: iMonths || 0
		};
	};

	Symbol.fn = Symbol.prototype;

	Symbol.fn.GetInputData = function ()
	{
		return this.InputData;	
	};
})(jQuery);